import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { useFinanceRequirementsData } from "@/pages/checkout/pre-checkout/how-to-finance/hooks/useFinanceRequirementsData";
import TabSelector from "@/pages/checkout/pre-checkout/how-to-finance/components/TabSelector";
import { AnimatePresence } from "framer-motion";
import RequirementsContent from "@/pages/checkout/pre-checkout/how-to-finance/components/RequirementsContent";
var FinanceRequirements = function FinanceRequirements(_ref) {
  var _ref$isNew = _ref.isNew,
    isNew = _ref$isNew === void 0 ? true : _ref$isNew;
  if (!isNew) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "px-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "py-3 bg-[#FCFCFC] border border-solid border-[#E9E9E9] rounded-lg md:flex md:flex-col md:gap-7"
    }, /*#__PURE__*/React.createElement(FinanceRequirementsUsed, null))));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "px-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "py-3 bg-[#FCFCFC] border border-solid border-[#E9E9E9] rounded-lg md:flex md:flex-col md:gap-7"
  }, /*#__PURE__*/React.createElement(FinanceRequirementsNew, null)));
};
var FinanceRequirementsNew = function FinanceRequirementsNew() {
  var _useState = useState('saudi'),
    activeTab = _useState[0],
    setActiveTab = _useState[1];
  var _useFinanceRequiremen = useFinanceRequirementsData(),
    newCarsData = _useFinanceRequiremen.newCarsData,
    tabs = _useFinanceRequiremen.tabs,
    usedCarsData = _useFinanceRequiremen.usedCarsData;
  var handleTabChange = function handleTabChange(tabKey) {
    setActiveTab(tabKey);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 px-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex justify-center"
  }, /*#__PURE__*/React.createElement(TabSelector, {
    tabs: tabs,
    activeTab: activeTab,
    onTabChange: handleTabChange
  }))), /*#__PURE__*/React.createElement(AnimatePresence, {
    mode: "wait"
  }, /*#__PURE__*/React.createElement(RequirementsContent, {
    key: activeTab,
    activeTab: activeTab,
    newCarsData: newCarsData
  })));
};
var FinanceRequirementsUsed = function FinanceRequirementsUsed() {
  var _useState2 = useState('saudi'),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  var _useFinanceRequiremen2 = useFinanceRequirementsData(),
    usedCarsData = _useFinanceRequiremen2.usedCarsData;
  var handleTabChange = function handleTabChange(tabKey) {
    setActiveTab(tabKey);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AnimatePresence, {
    mode: "wait"
  }, /*#__PURE__*/React.createElement(RequirementsContent, {
    key: activeTab,
    activeTab: activeTab,
    newCarsData: usedCarsData
  }))));
};
export default FinanceRequirements;